// redux/constants/relationshipConstants.js

export const RELATIONSHIP_DETAILS_REQUEST = 'RELATIONSHIP_DETAILS_REQUEST';
export const RELATIONSHIP_DETAILS_SUCCESS = 'RELATIONSHIP_DETAILS_SUCCESS';
export const RELATIONSHIP_DETAILS_FAIL = 'RELATIONSHIP_DETAILS_FAIL';

export const FETCH_RELATIONSHIPS_REQUEST = 'FETCH_RELATIONSHIPS_REQUEST';
export const FETCH_RELATIONSHIPS_SUCCESS = 'FETCH_RELATIONSHIPS_SUCCESS';
export const FETCH_RELATIONSHIPS_FAIL = 'FETCH_RELATIONSHIPS_FAIL';

export const CREATE_RELATIONSHIP_REQUEST = 'CREATE_RELATIONSHIP_REQUEST';
export const CREATE_RELATIONSHIP_SUCCESS = 'CREATE_RELATIONSHIP_SUCCESS';
export const CREATE_RELATIONSHIP_FAIL = 'CREATE_RELATIONSHIP_FAIL';
export const CREATE_RELATIONSHIP_RESET = 'CREATE_RELATIONSHIP_RESET';

export const UPDATE_RELATIONSHIP_REQUEST = 'UPDATE_RELATIONSHIP_REQUEST';
export const UPDATE_RELATIONSHIP_SUCCESS = 'UPDATE_RELATIONSHIP_SUCCESS';
export const UPDATE_RELATIONSHIP_FAIL = 'UPDATE_RELATIONSHIP_FAIL';

export const DELETE_RELATIONSHIP_REQUEST = 'DELETE_RELATIONSHIP_REQUEST';
export const DELETE_RELATIONSHIP_SUCCESS = 'DELETE_RELATIONSHIP_SUCCESS';
export const DELETE_RELATIONSHIP_FAIL = 'DELETE_RELATIONSHIP_FAIL';
